const SERVICES = [
  {
    id: "preventive-maintenance",
    num: "01",
    tag: "Scheduled",
    title: "Preventive Maintenance",
    description: "Don't wait for a breakdown. Regular oil changes, filter swaps, fluid checks, and inspections keep your vehicle running efficiently and catch small issues before they become expensive ones.",
  },
  {
    id: "ad-hoc-repairs",
    num: "02",
    tag: "On-Demand",
    title: "Ad Hoc Repairs",
    description: "Something went wrong? Give us a call. From brakes and belts to electrical issues and overheating. diagnosed fast, fixed right, explained clearly. No upsells, no mystery charges.",
  },
  {
    id: "summer-rebuilds",
    num: "03",
    tag: "Project Work",
    title: "Summer Rebuilds",
    description: "Prepping a classic, reviving a project car, or getting a daily driver ready for Texas heat? Full rebuilds handled with care - from engine work to cooling systems to drivetrain overhauls.",
  },
  {
    id: "diagnostics",
    num: "04",
    tag: "Diagnostic",
    title: "Diagnostics",
    description: "Check engine light on? Weird noise you can't place? Full diagnostic scans and systematic troubleshooting to find the real root cause - not just the first likely suspect.",
  },
  {
    id: "brakes-suspension",
    num: "05",
    tag: "Safety",
    title: "Brakes & Suspension",
    description: "Squealing brakes, spongy pedal, or a car that pulls to one side — safety systems get priority. Brake pads, rotors, calipers, shocks, struts, and alignment checks.",
  },
  {
    id: "cooling-fluids",
    num: "06",
    tag: "Seasonal",
    title: "Cooling & Fluids",
    description: "Texas summers are no joke. Radiator flushes, thermostat replacements, coolant system pressure tests, and full fluid services to keep your engine temperatures where they belong.",
  },
]

export default SERVICES